function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawBaby = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1074.54 840.74",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 513.67,
    y1: 843.12,
    x2: 513.67,
    y2: 56.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M339.27 29.67c29.18-26.03 75-31.3 116.77-29.3 131.09 6.52 249.42 69.8 351.78 141.39 37.06 25.91 73.54 53.84 97.59 89.53 49 72.65 34.44 173.29-33.64 233.14-23.17 20.36-51.25 36-80.08 49.81-51.26 24.6-106.57 44.35-164.75 50-41.48 4-83.48.75-124.73-4.84-115.23-15.63-228.34-50.19-323.15-109.31-41.58-25.93-80.79-58.17-97.91-100.12s-6.17-95.11 36.29-119.94c17.56-10.27 38.56-14.91 59.11-19.27 30.26-6.41 61-12.73 88.3-25.76 28.21-13.46 61.6-39.49 56-69.29-5.98-31.97-10.78-60.04 18.42-86.04z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 460.93,
    cy: 788.9,
    rx: 133.14,
    ry: 41.68,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M733.95 360.24l4.83 256.72 10.27 1.21-3.87-258.95-11.23 1.02z"
  }), React.createElement("path", {
    fill: "none",
    d: "M739.87 355.45l5.51 267.19 3.67-4.47-3.87-258.95-5.31-3.77z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M709.12 355.41l4.83 256.72 10.27 1.21-3.87-258.95-11.23 1.02z"
  }), React.createElement("path", {
    fill: "none",
    d: "M715.04 350.62l5.5 267.19 3.68-4.47-3.87-258.95-5.31-3.77z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M715.19 341.99l.5 280 10.5-1-4-284.5-7 5.5z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M425.56 295.24l4.43 232.71 10.27 1.08-3.46-234.73-11.24.94z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M431.49 290.89l5.08 242.2 3.69-4.06-3.46-234.73-5.31-3.41z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M447.41 301.13l4.43 232.7 10.27 1.08-3.46-234.72-11.24.94z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M453.34 296.77l5.09 242.2 3.68-4.06-3.46-234.72-5.31-3.42z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M468.77 307.51l4.43 232.71 10.27 1.08-3.46-234.72-11.24.93z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M474.7 303.17l5.09 242.19 3.68-4.06-3.46-234.72-5.31-3.41z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M489.55 308.81l4.56 240.88 10.27 1.12-3.6-242.96-11.23.96z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M495.47 304.31l5.23 250.7 3.68-4.2-3.6-242.96-5.31-3.54z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M512.08 310.69l4.57 240.87 10.27 1.12-3.6-242.96-11.24.97z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M518.01 306.19l5.23 250.69 3.68-4.2-3.6-242.96-5.31-3.53z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M534.22 318.56l4.56 240.88 10.27 1.12-3.59-242.96-11.24.96z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M540.14 314.06l5.23 250.7 3.68-4.2-3.59-242.96-5.32-3.54z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M559.56 323.76l4.68 247.6 10.27 1.15-3.71-249.74-11.24.99z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M565.48 319.14l5.35 257.69 3.68-4.32-3.71-249.74-5.32-3.63z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M581.61 326.39l4.67 247.6 10.28 1.15-3.72-249.74-11.23.99z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M587.53 321.76l5.35 257.7 3.68-4.32-3.72-249.74-5.31-3.64z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M604.97 332.99l4.68 247.6 10.27 1.16-3.71-249.74-11.24.98z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M610.9 328.37l5.34 257.7 3.68-4.32-3.71-249.74-5.31-3.64z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M405.55 294.83l-.5-14.74 5.2-2.84 372.94 76.49.69 18.71-378.33-77.62z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M410.25 277.25l374.31 76.43-.38 7.01-378.36-81.03"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M425.69 661.67l-10.5 3.82h-10l-.5-394.54 5.5-7.64 5.31-1.56 6.69-1.01 3.5 400.93z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M425.69 661.67l-10.5 3.82-.65-393.76.96-9.98 6.69-1.01 3.5 400.93z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M630.35 340.32l4.68 247.59 10.27 1.16-3.71-249.74-11.24.99z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M636.27 335.69l5.35 257.7 3.68-4.32-3.71-249.74-5.32-3.64z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M655.92 344.23l4.77 252.89 10.27 1.18-3.81-255.07-11.23 1z"
  }), React.createElement("path", {
    fill: "none",
    d: "M661.84 339.51l5.44 263.2 3.68-4.41-3.81-255.07-5.31-3.72z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M682.25 348.86l4.83 256.72 10.27 1.21-3.86-258.95-11.24 1.02z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M688.17 344.07l5.51 267.2 3.67-4.48-3.86-258.95-5.32-3.77z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M280.19 585.99l-10.5 1-.49-276.19-.01-3.81 7-5.5.11 7.66 3.89 276.84zM317.19 570.49l-10.5 1-.49-271.68-.01-8.32 7-5.5.16 11.16 3.84 273.34zM378.19 545.49l-10.5 1-.48-268.25-.02-11.75 7-5.5.22 15.58 3.78 268.92zM404.69 535.49l-10.5 1-.47-261.7-.03-18.3 7-5.5.36 25.42 3.64 259.08zM298.69 582.99l-10.5 1-.5-278v-2l7-5.5.07 5.27 3.93 279.23zM352.69 557.99l-10.5 1-.49-272.76-.01-7.24 7-5.5.14 10.26 3.86 274.24zM335.19 562.99l-10.5 1-.48-271.11-.02-8.89 7-5.5.16 11.58 3.84 272.92z"
  }), React.createElement("path", {
    d: "M268.99 539.85l-2.5 5.25s-6.5 9.75-5.75 24.75-10.47 54.75-10.47 54.75 10.25 4.75 18 4.25 24.5 7.75 24.5 7.75l34.72 10.77 70.25 16.5s41.25 23 52.5 23 56 15.25 56 15.25 60.5 13.25 65.25 18.25 24.78 11.73 26.78 12 32.5 3.25 32.5 3.25 35.5 8.25 40.5-.5a45.08 45.08 0 0 0 5.75-16s15.75 3.5 20-1.75 4.5-16.5 9.5-16 25.5 6.75 27.75 4.5 14.25-28.75 22.75-24.75 23.25 10.25 23.25 10.25l-8.5-86.5-3.75-23.75s-136.25 55.5-141 55.5-358.03-96.77-358.03-96.77z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M767.27 464.1l-.75 122-141.53 54.27-358.5-95.25s-24.25-34.25-1.75-66.25c0 0-29-40 7-66l.89-.21 136.11-32.79 60.53 11.06 267.45 48.92s26.27 9.75 30.55 24.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M464.49 402.6c-6.75 3.5-55.75 16.25-65.5 24s-77.25 13.77-77.25 13.77l-7.5 1.5s.5-5-29.25-19.5a37.93 37.93 0 0 1-12.36-9.71l136.11-32.79 60.53 11.06c.08 4.79-.74 9.57-4.78 11.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M258.74 354.37s-2.5 48.5 27.25 63 29.28 19.48 29.28 19.48l7.5-1.5s-26-29-24.25-34-23.25-30.25-26.78-31.25-13-15.73-13-15.73z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M259.27 355.1s-2.5 48.5 27.25 63 29.25 19.5 29.25 19.5l7.5-1.5s-26-29-24.25-34-23.28-30.25-26.75-31.25-13-15.75-13-15.75z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M266.27 375.6s24 36.25 28.25 37.5-22.53-37-28.25-37.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M255.27 347.6s15.5-12.5 17.5-15 24-3.5 24.75-3.5 17.5-10.25 36.25-13.5 26.25-4.75 26.25-4.75 27.5-11.5 29-14 14.25-5.25 30 7 50.5 67.25 50.75 73.25 2.5 17-4.25 20.5-55.75 16.25-65.5 24-77.28 13.77-77.28 13.77l-25.47-27.77-13.5-21.75-22.5-23.75z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M297.07 563.52s-9.33 2-4 7.33 4-7.33 4-7.33zM329.74 574.19s-10 12-8 15.33 8-15.33 8-15.33zM388.41 589.52s-10 12-8 15.33 8-15.33 8-15.33zM459.74 609.52s-10 12-8 15.33 8-15.33 8-15.33zM555.74 633.52s-10 12-8 15.33 8-15.33 8-15.33zM358.41 577.52s-10 12-8 15.33 8-15.33 8-15.33zM497.74 619.52s-10 12-8 15.33 8-15.33 8-15.33zM527.07 628.85s-10 12-8 15.34 8-15.34 8-15.34zM414.41 597.52s-10 12-8 15.33 8-15.33 8-15.33zM666.41 670.19l10.58 48.91s.08-34.25-10.58-48.91zM699.07 677.52l7.42 23.85s-.75-9.18-7.42-23.85zM734.27 705.85s-15.83-57.66-19.17-61.66 9.64 58 19.17 61.66zM753.07 678.85s-18.66-32.66-11.33-38.66 11.33 38.66 11.33 38.66zM264.74 478.85l362.33 81.34 139.34-40.67-140.67 36.67s-350-80.67-361-77.34z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M275.69 390.49l.5 232.75 10.25 1.25.5-234.75-11.25.75z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M281.69 386.24l1 242.25 3.75-4 .5-234.75-5.25-3.5z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M297.44 396.74l.5 232.75 10.25 1.25.5-234.75-11.25.75z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M303.44 392.49l1 242.25 3.75-4 .5-234.75-5.25-3.5z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M318.69 403.49l.5 232.75 10.25 1.25.5-234.75-11.25.75z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M324.69 399.24l1 242.25 3.75-4 .5-234.75-5.25-3.5z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M339.44 405.14l.5 240.92 10.25 1.29.5-242.99-11.25.78z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M345.44 400.74l1 250.75 3.75-4.14.5-242.99-5.25-3.62z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M361.94 407.39l.5 240.92 10.25 1.29.5-242.99-11.25.78z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M367.94 402.99l1 250.75 3.75-4.14.5-242.99-5.25-3.62z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M383.94 415.64l.5 240.92 10.25 1.29.5-242.99-11.25.78z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M389.94 411.24l1 250.75 3.75-4.14.5-242.99-5.25-3.62z"
  }), React.createElement("path", {
    fill: "none",
    d: "M409.19 421.26l.5 247.64 10.25 1.33.5-249.77-11.25.8z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M415.19 416.74l1 257.75 3.75-4.26.5-249.77-5.25-3.72z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M431.19 424.26l.5 247.64 10.25 1.33.5-249.77-11.25.8z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M437.19 419.74l1 257.75 3.75-4.26.5-249.77-5.25-3.72z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M454.44 431.26l.5 247.64 10.25 1.33.5-249.77-11.25.8z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M460.44 426.74l1 257.75 3.75-4.26.5-249.77-5.25-3.72z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M479.69 439.01l.5 247.64 10.25 1.33.5-249.77-11.25.8z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M485.69 434.49l1 257.75 3.75-4.26.5-249.77-5.25-3.72z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M505.19 443.36l.5 252.92 10.25 1.36.5-255.1-11.25.82z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M511.19 438.74l1 263.25 3.75-4.35.5-255.1-5.25-3.8zM531.44 448.43l.5 256.77 10.25 1.38.5-258.98-11.25.83z"
  }), React.createElement("path", {
    fill: "none",
    d: "M537.44 443.74l1 267.25 3.75-4.41.5-258.98-5.25-3.86z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M558.19 455.43l.5 256.77 10.25 1.38.5-258.98-11.25.83z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M564.19 450.74l1 267.25 3.75-4.41.5-258.98-5.25-3.86zM582.94 460.68l.5 256.77 10.25 1.38.5-258.98-11.25.83z"
  }), React.createElement("path", {
    fill: "none",
    d: "M588.94 455.99l1 267.25 3.75-4.41.5-258.98-5.25-3.86z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M262.19 668.49l-10.5 4h-10l-.5-367 5.5-8 5.31-1.63 7.69-2.37 2.5 375z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M262.19 668.49l-10.5 4-.65-366.19.96-10.44 7.69-2.37 2.5 375z"
  }), React.createElement("circle", {
    cx: 252.69,
    cy: 671.99,
    r: 12,
    fill: "#40414d"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M799.19 724.67l-10.5 3.82h-10l-.5-403.54 5.5 1.36 5.31-1.56 7.69-2.26 2.5 402.18z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M799.19 724.67l-10.5 3.82-.65-393.76.96-9.98 7.69-2.26 2.5 402.18z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M653.69 648.99l-10.5 1-.48-269.59-.02-10.41 7-5.5.2 14.37 3.8 270.13zM690.69 633.49l-10.5 1-.47-264.61-.03-15.39 7-5.5.26 18.26 3.74 266.24zM751.69 608.49l-10.5 1-.47-263.99-.03-16.01 7-5.5.26 18.51 3.74 265.99zM767.19 319.49l.5 280 10.5-1-4-284.5-7 5.5zM672.19 645.99l-10.5 1-.48-271.12-.02-8.88 7-5.5.17 12.21 3.83 272.29zM708.69 625.99l-10.5 1-.47-263.91-.03-16.09 7-5.5.26 18.68 3.74 265.82zM729.02 619.32l-10.5 1-.47-263.91v-1.57l-.03-14.52 7-5.5.24 17.06.02 1.62 3.74 265.82z"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M632.69 647.16l145-61.67 10 2.33.33 23-152.66 59-2.67-22.66z"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M777.69 585.49l-145 61.67 154.46-59.47"
  }), React.createElement("path", {
    fill: "#f5c5cc",
    d: "M257.02 614.49l365.67 111-.67 18-366.33-113 1.33-16z"
  }), React.createElement("path", {
    d: "M638.69 788.49l-10.5 4h-10l-.5-411v-2l.78-1.14 4.72-6.86 5.31-1.63 7.69-2.37.08 14z",
    fill: "#f5c5cc"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M638.69 788.49l-10.5 4-.65-412.19.96-10.44 7.69-2.37 2.5 421z"
  }), React.createElement("path", {
    d: "M636.19 367.49l.08 14a85.24 85.24 0 0 1-8.73.82c-7.2.28-9.85-.81-9.85-.81 0-.14.28-1.26.78-3.13l4.72-6.86 5.31-1.63zM649.69 364.49l.2 14.37q-3.87.9-7.18 1.54v-10.41zM668.19 361.49l.17 12.21c-2.49.79-4.88 1.51-7.15 2.17v-8.88zM686.69 348.99l.26 18.26q-3.75 1.39-7.23 2.63v-15.39zM704.69 341.49l.26 18.68-5.76 2.32-1.47.59v-16.09zM747.95 342.5l-7.23 3v-16l7-5.5zM725.27 351.88l-7.21 3v-14.52l7-5.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M802.69 331.49s-18.5 0-23.5-1.5-15.5 4.5-80 30.5c-39 15.73-60.65 19.38-71.65 19.81-7.2.28-9.85-.81-9.85-.81s13.17-60.42 55.11-71.71a124.39 124.39 0 0 0 13.77-4.63l.81-.31a82 82 0 0 1 10.81-3.35c13.46-3.09 23.07-9 47.4-9.18a66.55 66.55 0 0 1 41.78 13.86c8.34 6.56 15.53 15.63 15.32 27.32z",
    fill: "#cc929b"
  }), React.createElement("path", {
    d: "M689.19 302.49c-51.9 22.38-59.82 64.21-61.65 77.81-7.2.28-9.85-.81-9.85-.81s13.17-60.42 55.11-71.71a124.39 124.39 0 0 0 13.77-4.63l.81-.31c.6-.09 1.2-.21 1.81-.35z",
    fill: "#f5c5cc"
  }), React.createElement("path", {
    d: "M276.19 301.49l.11 7.66c-2.53.63-4.89 1.18-7.1 1.65v-3.81zM294.69 298.49l.07 5.27q-3.69 1.22-7.07 2.23v-2zM313.19 285.99l.16 11.16q-3.69 1.41-7.15 2.66v-8.32zM331.19 278.49l.16 11.58q-3.45 1.33-7.14 2.81v-8.89zM348.69 273.49l.14 10.26q-3.4 1.14-7.13 2.48v-7.24zM374.19 260.99l.22 15.58c-2.21.46-4.6 1-7.2 1.67v-11.75zM401.05 276.37a26.37 26.37 0 0 0-7.33-1.62v-18.3l7-5.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M426.19 276.49s-18.5 0-23.5-1.5-15.5-9.5-80 16.5c-39 15.73-60.65 19.38-71.65 19.81-7.2.28-9.85-.81-9.85-.81s9.93-52.5 53.72-61.36a64.38 64.38 0 0 0 7.23-1.85c2.69-.88 6.93-2.14 12.63-3.45 14.7-3.38 39.07-7.09 71.46-5.52a44.32 44.32 0 0 1 29.79 13.06 34.31 34.31 0 0 1 10.17 25.12z",
    fill: "#cc929b"
  }), React.createElement("path", {
    d: "M314.77 243.83c-51.9 22.38-61.9 53.87-63.73 67.47-7.2.28-9.85-.81-9.85-.81s9.93-52.5 53.72-61.36a64.38 64.38 0 0 0 7.23-1.85c2.69-.91 6.93-2.14 12.63-3.45zM255.69 389.74l-.25-14.75 5.25-2.75 359 80.5-1 18.75-363-81.75z",
    fill: "#f5c5cc"
  }), React.createElement("path", {
    fill: "#cc929b",
    d: "M260.69 372.24l359 80.5-.5 7-362.97-85.16"
  }), React.createElement("circle", {
    cx: 788.69,
    cy: 728.49,
    r: 12,
    fill: "#40414d"
  }), React.createElement("circle", {
    cx: 629.69,
    cy: 796.49,
    r: 12,
    fill: "#40414d"
  }), React.createElement("path", {
    d: "M269.36 549.82s-10.67 12-14 22.67 4 50.67 4 50.67a73.65 73.65 0 0 0 8-21.34c2.66-12.66 2-52 2-52zM775.69 649.49s6.5 33 7 38-16.5-2.5-16.5-2.5z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M641.42 270.81h-.17a2 2 0 0 0-.37-.94 4.91 4.91 0 0 0-1.66-1.26l-4.69-2.61 4.05 1.47a9.05 9.05 0 0 0-.63-.94l.47.26-.32-.45-.43-.15c-2.16-2.53-5.76-3.58-9.25-3.53h.06c.45-.06.91-.1 1.36-.13a16.23 16.23 0 0 0-3 .09 1.4 1.4 0 0 0 .35.1c-.32 0-.64.06-1 .1a3 3 0 0 1-1.57 0 2.27 2.27 0 0 1-1.21-1.65c-.5-2 .29-4.15.52-6.24a6.69 6.69 0 0 0-.31-2.91v-.6a3 3 0 0 0-2-1.84 1.85 1.85 0 0 0 0 .23l-.17-.07v5.38a21.45 21.45 0 0 1-4.09-4.26 1.87 1.87 0 0 1-.41-.85c-.1-.91 1.06-1.54 1.13-2.46a1.37 1.37 0 0 0-1-1.3l.3-.11a2.25 2.25 0 0 0-1.14-.2 19.16 19.16 0 0 0-2.52.76l.26.05a5.69 5.69 0 0 1-.59.16c-2.51.52-4.75-1.48-6.56-3.29l-.39-.39c-.86-7.53-2.25-16.16-2.25-16.16s-1.25-9.86-3-15.16-4.27-14.66-4.27-14.66-5.76-11.37-7-11.87a15.27 15.27 0 0 1-1.41-.8 22.39 22.39 0 0 1-1-5.24c-.31-9.94 10.31-17 11.91-26.85 1.31-8-3.73-16-3-24.11.34-3.55 1.77-6.89 2.54-10.37a27.93 27.93 0 0 0 .29-10.27 16.93 16.93 0 0 0-1.64-5.27 28.46 28.46 0 0 0 3.61-6.11c1.62-4.62-.13-9.78-2.66-14-8.13-13.43-24.6-24-40-25.37-6.21-.57-12.44-.68-18.66-.78-7.14-.13-14.52-.21-21.12 2.55-13.12 5.49-19.33 20.16-27.3 32a90.72 90.72 0 0 1-24.82 24.77c-4.61 3.08-10 6.36-11.08 11.83a10.77 10.77 0 0 0-.19 1.59 14.66 14.66 0 0 1-.33-1.46c-1.09 5.71 2.94 11 5 16.45a29 29 0 0 1 1.84 8.89 38.88 38.88 0 0 0 0-4.32c2 10.38-1.67 21.52-3.94 32.13-.17.78-.3 1.56-.46 2.34a19.13 19.13 0 0 0-5.26 2.37 29.58 29.58 0 0 1-11.82 4.6 22.08 22.08 0 0 0-14.22 8.54c-.64.86-1.26 1.45-1.8 1.51-2.25.26-14.79 39.42-14.79 39.42S407 255.55 407 259.33s-4.51 31.08-4.51 31.08-1.51 5-1 7.07c.29 1.15-.4 5-1.05 8.1a1.8 1.8 0 0 1-.7-.52c-.75-1.51-14.55 0-10.28 10.11a19.82 19.82 0 0 0 4.83 7.18c-1.9 4.76-3.55 9.19-3.33 9.75 0 0 0 3.61.32 8.07-2.93 2-5.33 3.8-5.33 3.8-.21 5.52 3.47 6.4 6.93 6.2.89 3.2 2.19 5.74 4.1 6.43 6.27 2.28 10.28 1.27 12.29 3s12.73 5.09 12.73 5.09a126.76 126.76 0 0 0 13.74 1.31l1.84.92-.22-1c.59-.11.32-.81-.42-2a680.1 680.1 0 0 1-1.22-5.81l2.75-1 .75 1.11c-1 5.24-1.64 8.73-1.64 8.73s-5 17.94-2.76 20.72 0 6.32 0 6.32-.5 4.54.76 4.54 2.75 5.81 1.5 6.07-7 5.05-5 6.06 0 3.28 0 5.56c0 1.66 3.06 4.12 4.72 5.33-.3 1.08-.61 2.23-.9 3.36-.86 3.34-1.53 6.56-1.32 7.73.5 2.78-1.25 10.61-.75 13.14s2.26 8.08 1 10.36.25 9.85.25 9.85l2.26 21.47s-1.5 6.07 0 7.58 2.76 19.21 4.26 21.23 3.77 12.63 2 16.17 2.26 10.86 2.26 10.86-.25 8.59-.25 10.86 2.25 5.81 2.25 5.81 2.26 12.13 2 15.16 1.5 7.33 1.5 7.33 1.51 8.84 1.26 10.86 2 4.8 2 4.8 2.76 6.57 2 9.35 1.75 5.56 1.75 5.56-.25 6.06-.25 6.82 5.27 6.82 5.27 6.82-2.26 4.55-1 6.32 1 8.08 3 10.11 1.5 10.35 4 11.87 4.76 2.78 5.26 6.06 2.51 8.09 4.77 8.85a4.35 4.35 0 0 1 1.1 1.09l-1 4.25-3.09 12.85s-3 18.69-2.76 21.47-3 5.56-3 5.56-2.76 16.17-3.26 18.19.25 5.81.25 5.81-1.75 9.6-.5 10.11 6.52 5.81 6.52 5.81h.41l-.54 1.9-8.65 30.7s-8 13.39 10.54 20.21c.62 1.2 1.19 1.23.52 1 .61.52 13 11 14 15.91s9.53 10.1 12.54 10.61 23.07 16.67 30.34.76-12.79-26.28-12.79-26.28L504.78 800s-7.77-11.37-9-13.39-3.51-11.88-2-13.39c.77-.78 3.18-7.7 5.36-14.28.2-.63.41-1.25.61-1.87 4.26 1 9.08-1 9.08-1L520 738.45l2-3.09.36.72s9.28.76 13.79 1.52a13 13 0 0 0 4.24-.53c.17.37.34.75.5 1.13a55.3 55.3 0 0 1 2.78 7.23c.75 3.28 1.51 14.9 1.51 14.9s-5 16.68-6.27 19.71 1.25 28.3 26.08 18.19c0 0 3-4.8 5.76-4.8s9.53-6.82 7-14.15-13-29.81-5.76-41.68c5.84-9.56 5.37-22.38-2.48-28.34-.33-.25-.68-.47-1-.69a28.64 28.64 0 0 0 0-3.82c-1.76-24.25-13-25.52-13-25.52s-6.52-1.51-7.27-4c-.44-1.46-6.09-9-10.77-15.13.16-.26.31-.52.46-.78 0-.09.1-.18.14-.27.22-.41.43-.83.63-1.27 3.64-8.18 2.7-20.08 2.51-22.21-.25-2.78 0-6.32 0-10.36s4-10.11 3.51-12.38 4.77-11.62 4.77-13.9 3.69-15.93 3.69-15.93 7.27-15.67 8.78-20.22c1.44-4.36 27.12-83.84 29.2-90.28a3.91 3.91 0 0 1 .14-.42s8.2-26.83 2.71-44.45a28.25 28.25 0 0 0-1.29-3.41c1.68-.81 2.84-1.4 2.84-1.4s-3.26-9.6-1.76-13.14.5-10.36.5-10.36-6-3.54-6.26-5.05-2.76-3.54-2-5.56 5-1 4.51-5.56-5.76-9.35-5.26-12.13 2.5-7.83 0-10.86-3.51-7.83-3.76-11.62c-.07-1 .15-3.95.5-7.84a88.06 88.06 0 0 0 8.27 4.55s10.78 1.52 11.29.51a23.77 23.77 0 0 1 3.26-3.54c13.54-3.28 7.52-28 7.52-28s-.2-1.81-.52-4.79a2.63 2.63 0 0 0 .94-.45c1.15-.84 1.43-2.44 2.13-3.7a18.38 18.38 0 0 1 2.78-3.26c2.48-2.7 3.95-6.15 5.37-9.54.9-2.16 1.82-4.32 2.73-6.49s2-4.76 4-6.33c2.3-1.85 5.42-2.21 8.35-2.48a10.45 10.45 0 0 0-2.39-6.12 6.14 6.14 0 0 1 5.26.8 2.12 2.12 0 0 0 .11-.21h.06a1.35 1.35 0 0 0 .23-.84zM427.29 340c.06-.5.15-1 .26-1.5.49-.46 1.08-1 1.71-1.5l3.5.34c-.86.7-1.61 1.34-2.22 1.86-1.08-.55-2.26-.01-3.25.8zm7-6.93a5.38 5.38 0 0 0 1.45-.31h3.06a92.098 92.098 0 0 0-4.86 3.68l.35-3.29zm5.77-51s-.23 7.18.28 14.4c-.78.55-1.59 1.15-2.39 1.78l1.77-16.65z",
    transform: "translate(-62.73 -29.63)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M507.94 762.74c-2.75 0-5.75 4.75-5.75 4.75-24.75 10-27.25-15-26-18s6.25-19.5 6.25-19.5-.75-11.5-1.5-14.75a55.77 55.77 0 0 0-2.77-7.15c-1.68-3.83-3.48-7.6-3.48-7.6s10.75-26.5 25-24a16.08 16.08 0 0 1 7 3c7.83 5.9 8.3 18.59 2.47 28-7.25 11.75 3.25 34 5.75 41.25s-4.22 14-6.97 14zM470.19 804.99c-7.25 15.75-27.25-.25-30.25-.75s-11.5-5.5-12.5-10.5-13.37-15.23-14-15.74c.67.21.1.18-.52-1-18.5-6.75-10.5-20-10.5-20l8.62-30.38 2.38-8.37 27-1.75s-1.85 5.91-3.91 12.12c-2.17 6.51-4.57 13.36-5.34 14.13-1.5 1.5.75 11.25 2 13.25s9 13.25 9 13.25l15.25 9.75s20.02 10.24 12.77 25.99z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M440.44 716.49s-1.85 5.91-3.91 12.12a7.19 7.19 0 0 1-3.59-2.37l-21.75.5-.13-.13 2.38-8.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M528.44 444.74s0 .14-.13.41c-2.08 6.37-27.68 85-29.12 89.34-1.5 4.5-8.75 20-8.75 20s-3.75 13.5-3.75 15.75-5.25 11.5-4.75 13.75-3.5 8.25-3.5 12.25-.25 7.5 0 10.25c.19 2.11 1.12 13.89-2.51 22a14.79 14.79 0 0 1-3.45 5 10.71 10.71 0 0 1-1.29 1c-9 6-9.75 67.5-9.75 67.5l-.42.66-3.65 5.72-11.18 17.4s-9 3.75-13.25-1.5l-21.75.5s-5.25-5.25-6.5-5.75.5-10 .5-10-.75-3.75-.25-5.75 3.25-18 3.25-18 3.25-2.75 3-5.5 2.75-21.25 2.75-21.25l3.08-12.71 1.52-6.27 3.15-13 21.25-187.75 27-8.25 52 2.5 5.7 10.3z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M455.19 536.99c-.25 4.75-1.5 12-1 16.25s2.25 20.25 1.5 23.25 2.75 6.5 4 8 .5 6 .75 9.5 3.5 6.75 3.5 6.75-3.75 8-1 9.25 8.5 12.75 8.5 12.75 1.93 2.43 4.49 5.73a13.71 13.71 0 0 1-4.74 6c-9 6-9.75 67.5-9.75 67.5l-.42.66-5.58-11.16s-33.25-50.25-35.5-51a3.52 3.52 0 0 1-1.4-1l3.15-13 21.25-187.75 27-8.25 52 2.5-27.38 2.75s-12.17 8.73-12.25 9l-21.87 9.25-4 60s-1 18.27-1.25 23.02z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M527.64 443.29c-.69 2.78-72.7-5.55-72.7-5.55l.5 19.25-4 60s-1 18.25-1.25 23-1.5 12-1 16.25 2.25 20.25 1.5 23.25 2.75 6.5 4 8 .5 6 .75 9.5 3.5 6.75 3.5 6.75-3.75 8-1 9.25 8.5 12.75 8.5 12.75 2.75 3.47 6 7.73a10.71 10.71 0 0 1-1.29 1c-9 6-9.75 67.5-9.75 67.5l-.42.66-3.61 5.74-6.93-13.85s-25.65-38.77-33.42-48.71l1.52-6.27 3.15-13 21.25-187.75 27-8.25 52 2.5zM506.72 679.45c-1 17.9-19.86 26.66-28.55 28.64-1.68-3.83-3.48-7.6-3.48-7.6s10.75-26.5 25-24a16.08 16.08 0 0 1 7.03 2.96z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M452.19 536.99c-.25 4.75-1.5 12-1 16.25s2.25 20.25 1.5 23.25 2.75 6.5 4 8 .5 6 .75 9.5 3.5 6.75 3.5 6.75-3.75 8-1 9.25 8.5 12.75 8.5 12.75 16.25 20.5 17 23 7.25 4 7.25 4 11.25 1.25 13 25.25-27.75 33.25-32.25 32.5-13.75-1.5-13.75-1.5l-7.25-14.5s-33.25-50.25-35.5-51-4.25-5.5-4.75-8.75-2.75-4.5-5.25-6-2-9.75-4-11.75-1.75-8.25-3-10 1-6.25 1-6.25-5.25-6-5.25-6.75.25-6.75.25-6.75-2.5-2.75-1.75-5.5-2-9.25-2-9.25-2.25-2.75-2-4.75-1.25-10.75-1.25-10.75-1.75-4.25-1.5-7.25-2-15-2-15-2.25-3.5-2.25-5.75.25-10.75.25-10.75-4-7.25-2.25-10.75-.5-14-2-16-2.75-19.5-4.25-21 0-7.5 0-7.5l-2.25-21.25s-1.5-7.5-.25-9.75-.5-7.75-1-10.25 1.25-10.25.75-13c-.21-1.16.46-4.34 1.31-7.65 1.18-4.56 2.69-9.35 2.69-9.35s128.5-12 147 .5c4 2.68 6.47 6.75 8 11.51 5.47 17.44-2.71 44-2.71 44l-71 9.25-4 60s-1.04 18.24-1.29 22.99z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M431.69 625.99s22.25-6.75 27.5-2.25-27.5 2.25-27.5 2.25zM439.69 654.49s6.75-7.25 16.75-5a27.25 27.25 0 0 0 17.5-1.75zM463.19 662.74s18.25-2.5 19-.25-19 .25-19 .25zM457.94 677.49s20.25-6 21.25-3.5-22.25 3.25-22.25 3.25zM480.69 542.74s-19 16.75-16.25 18.5 16.25-18.5 16.25-18.5zM465.19 584.24s13.25 0 10.75 3-10.75-3-10.75-3zM473.19 595.99s-5.25 4.5-4 5.5 4-5.5 4-5.5zM415.44 703.24s16.5 5.5 16.75 9-16.75-9-16.75-9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M495.44 180.49l-5.25 31.25s-45.5 24-46.25 24-33.25-5.5-34.5-5.5-22.5-64.25-7.5-68.25c4.06-1.08 9.95-3.68 16.38-6.91 17.34-8.67 38.62-21.84 38.62-21.84s31.75-3.5 24 18.5c-3 8.63-1.46 14.91 1.57 19.36 4.76 6.9 12.93 9.39 12.93 9.39z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M495.44 180.49l-5.25 31.25s-45.5 24-46.25 24-33.25-5.5-34.5-5.5-22.5-64.25-7.5-68.25c4.06-1.08 9.95-3.68 16.38-6.91 4.09.27 6.87.66 6.87.66s10 38.25 10.75 50 26.75 13 28.5 12.5 9-29.25 9-29.25-.75-10 1.5-10c1.88 0 6.22-6 7.57-7.89 4.76 6.9 12.93 9.39 12.93 9.39zM531.15 400.75c-3.48 1.7-11.8 5.58-14 5-2.75-.75-9.5-.75-9.5-.75s-4 4.5-8.25 3.5-21-.25-21-.25-30 1.25-35.75-.75-26.25-3.75-26.25-3.75-28-3.25-32.75-5.25a8.19 8.19 0 0 0-8.25 1s-.87-.57-1.94-1.4c1.18-4.56 2.69-9.35 2.69-9.35s128.5-12 147 .5c4 2.67 6.51 6.74 8 11.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M425.19 157.74s-25.25-3.5-35.25 3.25a29.58 29.58 0 0 1-11.78 4.55 22.05 22.05 0 0 0-14.18 8.45c-.64.86-1.26 1.44-1.79 1.5-2.25.25-14.75 39-14.75 39l30.25 42.25s-.75 23.5 3.5 28-6 56-6 56-5 17.75-2.75 20.5 0 6.25 0 6.25-.5 4.5.75 4.5 2.75 5.75 1.5 6-7 5-5 6 0 3.25 0 5.5 5.75 6 5.75 6a8.19 8.19 0 0 1 8.25-1c4.75 2 32.75 5.25 32.75 5.25s20.5 1.75 26.25 3.75 35.75.75 35.75.75 16.75-.75 21 .25 8.25-3.5 8.25-3.5 6.75 0 9.5.75 15.5-5.75 15.5-5.75-3.25-9.5-1.75-13 .5-10.25.5-10.25-6-3.5-6.25-5-2.75-3.5-2-5.5 5-1 4.5-5.5-5.75-9.25-5.25-12 2.5-7.75 0-10.75-3.5-7.75-3.75-11.5 3.75-37.75 3.75-37.75l-9.25-68.5 28.25-14s-1.25-9.75-3-15-4.25-14.5-4.25-14.5-5.75-11.25-7-11.75-14.5-9.25-17.5-8-26.75 19.5-26.75 19.5-5.75 8.5-8 8.5-1.5 10-1.5 10-7.25 28.75-9 29.25-27.75-.75-28.5-12.5-10.75-50-10.75-50z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M385.99 305.55a56.69 56.69 0 0 1-10.55 1.3c-5.13.14-9.64-.51-10.75-2.36-3-5-3-14.5-3-14.5s13.56 3.13 22.92 6.55l1.55.58c3.63 1.41 6.39 2.85 7 4.11.87 1.69-2.48 3.27-7.17 4.32z",
    fill: "#fdc2cc"
  }), React.createElement("circle", {
    cx: 484.19,
    cy: 120.74,
    r: 45.75,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 484.19,
    cy: 118.74,
    r: 45.75,
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M382.94 365.74s13 0 18 1.25 15.5 1.5 15.5 1.5-29-1-33.5-2.75zM383.44 373.74s16.75 1.25 17 3.75-17-3.75-17-3.75zM510.94 342.99s10.25 3.75 10 5-9-2-10-5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M353.94 209.99l-6.5 4.5s-2.75 16-2.75 19.75-4.5 30.75-4.5 30.75-1.5 5-1 7-2 12.25-2 12.25-9 20.75-8.5 22 42.75 5.25 42.75 5.25l6-56z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M334.94 299.49l-6.25 6.75s-.25 22 6 24.25 10.25 1.25 12.25 3 12.75 5 12.75 5 11.75 1.75 15.25 1.25-20.5-19.75-4.75-36zM532.69 192.49l8.75 9.75s3.75 23.25 2.75 26.5 5.25 59.75 5.25 59.75 6 24.5-7.5 27.75a23.59 23.59 0 0 0-3.25 3.5c-.5 1-11.25-.5-11.25-.5l-16.5-108.25z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M413.69 281.99s32.75-19.5 38.75-20.5 43.25-18.75 43.25-18.75 18.5 9.5 20.25 16.75-7.75 36.25-7.75 36.25-30.5 21.25-32.25 25.75-28 17.75-28 20-41.5 26.75-59.75 5.25-18-27.75-18-27.75l46.25-10.75 4.5-20z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M413.69 279.99s32.75-19.5 38.75-20.5 43.25-18.75 43.25-18.75 18.5 9.5 20.25 16.75-7.75 36.25-7.75 36.25-30.5 21.25-32.25 25.75-28 17.75-28 20-41.5 26.75-59.75 5.25-18-27.75-18-27.75l46.25-10.75 4.5-20z",
    fill: "#c4c8e2"
  }), React.createElement("path", {
    d: "M363.19 288.74l-1.5 12.5-11.89-.87-11.61-.86s-6.75 0-11-10 9.5-11.5 10.25-10c.57 1.13 15 5.84 22 8.07z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M363.19 288.74l-1.5 12.5-11.89-.87c1.94-2.88 6-8.15 9.65-12.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M361.69 289.99s13.56 3.13 22.92 6.55c-.62 1-4.76 7.48-9.17 10.31-5.13.14-9.64-.51-10.75-2.36-3-5-3-14.5-3-14.5zM385.99 305.55l-.22-1.73s-.1-.37-.19-.93c-.18-1.14-.31-3.06.53-4.23.49-.69.38-1.18.06-1.53 3.63 1.41 6.39 2.85 7 4.11.86 1.68-2.49 3.26-7.18 4.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M428.44 297.37s-13.58 13.59-14.42 16.5-26.5 3-26.5 3l-1.75-14s-.1-.37-.19-.93c-.18-1.14-.31-3.06.53-4.23 1.25-1.75-1.42-2.25-1.42-2.25s-6.92 11.41-12.75 11.75c0 0-8.08 5.83-8 7 0 0-3.92 3.58-4 7.91s-5.08 6.09-8.75 4.84-12.75-3.92-15.67-3.5-12.16 3.16-11.83-5.42c0 0 12-9 15-8.75s10-3.25 11-6 18-23.75 18-23.75 10.75-10.17 15.08-11.17c0 0 8.67-6.75 21.75 3.5 0 0 18.09 11.16 18.67 12.66.46 1.18 5.71 6.22 6.15 10a3.09 3.09 0 0 1-.9 2.84z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M386.02 277.49s1.33 7.67.67 10.42-2 7.5-2 7.5 8.08-12.67 1.33-17.92zM386.6 296.16s4.17-4.59 5.09-3.42-5.09 3.42-5.09 3.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M557.32 249.37a29.26 29.26 0 0 1-21.24 28.14 28.78 28.78 0 0 1-7.87 1.12h-.15a29.25 29.25 0 0 1-29.24-29.26 27.86 27.86 0 0 1 .46-5.12 29.2 29.2 0 0 1 26.66-24c.7-.06 1.41-.09 2.12-.09a29.25 29.25 0 0 1 29.26 29.21z",
    fill: "#f8bdc5"
  }), React.createElement("path", {
    d: "M572.75 245.78a10.29 10.29 0 0 1 2.38 6.06c-2.92.27-6 .62-8.32 2.45-2 1.56-3 4-4 6.27q-1.37 3.21-2.72 6.42c-1.42 3.35-2.88 6.77-5.35 9.44a18.48 18.48 0 0 0-2.78 3.22c-.69 1.25-1 2.83-2.12 3.67a4 4 0 0 1-3.78.21c-1.23-.46-2.33-1.23-3.56-1.72a11.33 11.33 0 0 0-2.45-.64c-3.66-.54-7.69.25-10.8-1.72a6.44 6.44 0 0 1-1-.82 9.68 9.68 0 0 1-2.55-4.32 4.86 4.86 0 0 1-.24-2.07 4.47 4.47 0 0 1 2.32-3c.17-.1.34-.2.52-.29 3-1.57 7.17-1.94 8.74-5 1.5-2.9-.36-6.43-2.64-8.77-1.08-1.1-2.36-2.35-2.21-3.89.14-1.36 1.35-2.31 2.36-3.22a17.52 17.52 0 0 0 5.48-9.83 7.47 7.47 0 0 0-.06-3.55 9.41 9.41 0 0 0-1.27-2.33l-3.24-4.8a13.17 13.17 0 0 0-4-4.24c-1.35-.81-2.9-1.09-4.26-1.89a3.38 3.38 0 0 1-1.26-1.2 1.29 1.29 0 0 1-.16-.94c.17-.8 1-1.19 1.83-1.42a17.83 17.83 0 0 1 6.62-.63 5.14 5.14 0 0 0 2.14 0 1.51 1.51 0 0 0 1.11-1.63c2.46-.64 4.79 1.28 6.59 3.08s4 3.77 6.54 3.26c.91-.18 1.75-.7 2.67-.8s2.06.5 2 1.43-1.22 1.53-1.12 2.43a1.79 1.79 0 0 0 .41.84 21.14 21.14 0 0 0 4.07 4.22v-5.32c2 .5 2.73 3.06 2.5 5.13s-1 4.16-.52 6.18a2.27 2.27 0 0 0 1.2 1.63 3 3 0 0 0 1.57 0c4.59-.65 9.95.57 12.23 4.6l-4-1.45 4.65 2.54a4.89 4.89 0 0 1 1.66 1.25 1.66 1.66 0 0 1 .12 1.94 6.21 6.21 0 0 0-5.3-.78z",
    fill: "#585268"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M563.94 237.45a3 3 0 0 0 1.57 0c.45-.06.9-.1 1.36-.13a16.12 16.12 0 0 0-3 .09zM573.7 240.63l1.72.95-.32-.45zM560.8 229.83v-3.5a3.08 3.08 0 0 0-2-1.82v3.52a21.5 21.5 0 0 0 2 1.8zM575.7 245.43a6.2 6.2 0 0 1 2.46 1 1.24 1.24 0 0 0 .25-.81 6.36 6.36 0 0 0-2.71-.19zM548.27 283.37c-1.23-.46-2.33-1.23-3.56-1.72a11.33 11.33 0 0 0-2.45-.64c-3.66-.54-7.69.25-10.8-1.72a6.44 6.44 0 0 1-1-.82 9.68 9.68 0 0 1-2.55-4.32 4.86 4.86 0 0 1-.24-2.07 4.47 4.47 0 0 1 2.32-3c.17-.1.34-.2.52-.29 3.05-1.57 7.17-1.94 8.74-5 1.5-2.9-.36-6.43-2.64-8.77-1.08-1.1-2.36-2.35-2.21-3.89.14-1.36 1.35-2.31 2.36-3.22a17.52 17.52 0 0 0 5.48-9.83 7.47 7.47 0 0 0-.06-3.55 9.41 9.41 0 0 0-1.27-2.33l-3.24-4.8a13.17 13.17 0 0 0-4-4.24c-1.35-.81-2.9-1.09-4.26-1.89a3.38 3.38 0 0 1-1.26-1.2 1.29 1.29 0 0 1-.16-.94c.17-.8 1.05-1.19 1.83-1.42a18.49 18.49 0 0 1 4-.66 18 18 0 0 0-6 .66c-.78.23-1.66.62-1.83 1.42a1.29 1.29 0 0 0 .16.94 3.38 3.38 0 0 0 1.26 1.2c1.36.8 2.91 1.08 4.26 1.89a13.17 13.17 0 0 1 4 4.24l3.24 4.8a9.41 9.41 0 0 1 1.27 2.33 7.47 7.47 0 0 1 .06 3.55 17.52 17.52 0 0 1-5.48 9.83c-1 .91-2.22 1.86-2.36 3.22-.15 1.54 1.13 2.79 2.21 3.89 2.28 2.34 4.14 5.87 2.64 8.77-1.57 3.05-5.69 3.42-8.74 5-.18.09-.35.19-.52.29a4.47 4.47 0 0 0-2.32 3 4.86 4.86 0 0 0 .24 2.07 9.68 9.68 0 0 0 2.55 4.32 6.44 6.44 0 0 0 1 .82c3.11 2 7.14 1.18 10.8 1.72a11.33 11.33 0 0 1 2.45.64c1.23.49 2.33 1.26 3.56 1.72a4.72 4.72 0 0 0 2.82.24 5.91 5.91 0 0 1-.82-.24zM552.77 221.71a14.7 14.7 0 0 0 1.81-.59 2.15 2.15 0 0 0-1.14-.21 21.06 21.06 0 0 0-2.5.76 4.17 4.17 0 0 0 1.83.04zM536.39 217.05a5.14 5.14 0 0 0 2.14-.05 1.51 1.51 0 0 0 1.11-1.62 4 4 0 0 0-2 0 1.51 1.51 0 0 1-1.11 1.63 1.6 1.6 0 0 1-.21.05z"
  })), React.createElement("path", {
    d: "M501.69 233.37c-3.73 2.79-9.68 4-15.15 4.4a81.37 81.37 0 0 1-12.85 0l-9.63-3.62s.78-1.55 2.1-3.6c2.63-4.08 7.41-10.15 12.4-9.9 7.5.37 15.38.74 16.13.74s15.37 5.73 7 11.98z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M477.33 33.2c-7.12-.13-14.47-.21-21 2.53-13.13 5.43-19.32 19.94-27.26 31.64a90.49 90.49 0 0 1-24.75 24.51c-4.6 3-9.94 6.3-11.05 11.7-1.18 5.71 2.9 11 5 16.41 4.45 11.51 0 24.26-2.63 36.32a117.9 117.9 0 0 0-2.37 17.58 24.4 24.4 0 0 0 .53 8.18c2 7.06 9.56 12.16 9.62 19.5 0 5-3.52 9.72-2.49 14.58 1.33 6.21 8.87 8.45 15.12 9.52a7.73 7.73 0 0 0 4.55-.14c1-.48 1.82-1.4 2.84-1.91 3.47-1.72 7.32 1.91 11.2 1.84 4.87-.09 7.61-5.84 7.73-10.71s-1.18-10 .57-14.5c2.33-6 9-8.85 14.63-12 6.23-3.49 12.16-8.53 14-15.42 1.15-4.26.63-8.77.17-13.15-.7-6.72-1.25-13.47-1.63-20.21-1-17.2 13.29-31.53 30.46-30.19h.32c5 .41 10.9.89 14.43-2.75 1.4-1.45 2.29-3.45 4-4.45 3.34-1.9 7.93.81 11.29-1.06 2.63-1.47 3.19-5 2.78-8s-1.46-6-.9-8.94c.8-4.17 4.59-7.15 6-11.16 1.62-4.57-.13-9.68-2.65-13.82-8.07-13.31-24.5-23.73-39.9-25.13-6.19-.6-12.4-.67-18.61-.77z",
    fill: "#865a61"
  }), React.createElement("path", {
    d: "M466.16 230.52c5.94 1.22 13.17 3.93 20.38 7.24a81.37 81.37 0 0 1-12.85 0l-9.63-3.62s.78-1.57 2.1-3.62zM540.06 281.16c-3.66-.54-7.69.25-10.8-1.72a6.44 6.44 0 0 1-1-.82h-.15a29.25 29.25 0 0 1-29.29-29.25 27.86 27.86 0 0 1 .46-5.12c10.25 5.73 18.56 11.62 20.16 14.5a59.52 59.52 0 0 0 8.3 10.47c2.79 3 5.78 5.88 8.34 8.29 1.52 1.41 2.89 2.66 3.98 3.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M541.69 284.49s-18.25-15.75-23.25-24.75-75.25-47.25-66.25-18.25 40 31.75 40 31.75 10 11.25 11 16.75 4.5 13.5 4.5 13.5l16.75 7.5 7.75-1.75s18.25-10 9.5-24.75z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M506.69 302.49s29.5 16.75 32.5-22.5l7.5 2.5-7.5 26.5-12.75 9.25s-17.75-8.25-19.75-15.75z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M507.69 303.49s29.5 16.75 32.5-22.5l7.5 2.5-7.5 26.5-12.75 9.25s-17.75-8.25-19.75-15.75z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M533.74 104.59c.34-3.51 1.77-6.82 2.52-10.27a27.13 27.13 0 0 0 .3-10.16 14.75 14.75 0 0 0-2.64-6.76c-1-1.25-4-4-5.75-2.76-1 .71-1.27 4.82-1.67 6a51.81 51.81 0 0 1-5.6 11.25 45.74 45.74 0 0 1-37 72.58c-1.09 0-2.17-.05-3.24-.13-1 1.74-1.91 3.5-2.83 5.26a16.34 16.34 0 0 0-2.16 5.83 15.18 15.18 0 0 0 .89 5.8 81.81 81.81 0 0 0 7.66 17.49 26.45 26.45 0 0 1 2.75 5.47c.57 1.85.67 3.83 1.41 5.61 1.66 4 6 6 10 7.67 2.39 1 4.89 2 7.47 1.79a1.74 1.74 0 0 0 1.87-1.77 6.77 6.77 0 0 0-2-5.75 28.7 28.7 0 0 0 10.5 1.25 1.69 1.69 0 0 0 1.82-2.48 45 45 0 0 0-4.18-10.82c-1.82-3.36-4.14-7.27-2.48-10.7.95-2 2.95-3.12 4.77-4.31 6.15-4 11.6-10.52 11.12-17.85-.26-4-2.28-7.81-2.4-11.84-.31-9.83 10.27-16.86 11.87-26.57 1.27-7.94-3.77-15.8-3-23.83z",
    fill: "#865a61"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M402.88 197.57c-.06-7.34-7.61-12.44-9.62-19.5a16.42 16.42 0 0 1-.57-3.41 22.46 22.46 0 0 0 .57 7.41c1.84 6.45 8.28 11.27 9.43 17.66a12 12 0 0 0 .19-2.16zM434.1 221.46c-3.88.07-7.73-3.56-11.2-1.84-1 .51-1.8 1.43-2.84 1.91a7.73 7.73 0 0 1-4.55.14c-6.23-1.07-13.75-3.3-15.1-9.46a10.24 10.24 0 0 0 0 3.94c1.33 6.21 8.87 8.45 15.12 9.52a7.73 7.73 0 0 0 4.55-.14c1-.48 1.82-1.4 2.84-1.91 3.47-1.72 7.32 1.91 11.2 1.84 4.87-.09 7.61-5.84 7.73-10.71 0-1 0-2-.07-3-.51 4.62-3.15 9.62-7.68 9.71zM471.05 168.82c-1.86 6.89-7.79 11.93-14 15.42-5.63 3.16-12.3 6-14.63 12a19.13 19.13 0 0 0-.86 8.05 14.16 14.16 0 0 1 .86-4.05c2.33-6 9-8.85 14.63-12 6.23-3.49 12.16-8.53 14-15.42a25.28 25.28 0 0 0 .63-8 20.57 20.57 0 0 1-.63 4zM525.8 97.67c-2.41-.18-4.92-.74-7 .42-1.75 1-2.64 3-4 4.45-3.53 3.64-9.38 3.16-14.43 2.75h-.32c-17.17-1.34-31.44 13-30.46 30.19v.4a28.47 28.47 0 0 1 30.44-26.59h.32c5 .41 10.9.89 14.43-2.75 1.4-1.45 2.29-3.45 4-4.45 2-1.16 4.55-.6 7-.42a45.58 45.58 0 0 1 3.25 15c0-.65.05-1.3.05-2a45.68 45.68 0 0 0-3.28-17zM399.6 128.81a30.89 30.89 0 0 0-1.83-12.8c-1.58-4.09-4.29-8.1-5-12.27-1.09 5.65 2.94 10.88 5 16.27a28.68 28.68 0 0 1 1.83 8.8zM536.32 86.49a26 26 0 0 1-.56 3.83c-.75 3.45-2.18 6.76-2.52 10.27a19.68 19.68 0 0 0 0 3.76c.38-3.42 1.75-6.66 2.49-10a27.09 27.09 0 0 0 .59-7.86zM536.2 124.44c-1.6 9.71-12.18 16.74-11.87 26.57a13.81 13.81 0 0 0 .14 1.59c1.26-8.61 10.27-15.26 11.73-24.16a18.49 18.49 0 0 0 .1-4.87c-.03.29-.03.58-.1.87zM538.02 68.9a28 28 0 0 1-3.6 6 13.88 13.88 0 0 1 1 2.52 19.88 19.88 0 0 0 2.57-4.57 12 12 0 0 0 .46-5.8 10.57 10.57 0 0 1-.43 1.85zM526.61 165.76c-.89 6.12-5.68 11.45-11 14.94-1.82 1.19-3.82 2.35-4.77 4.31a6.62 6.62 0 0 0-.27 4.68 4.37 4.37 0 0 1 .27-.68c.95-2 2.95-3.12 4.77-4.31 6.15-4 11.6-10.52 11.12-17.85-.02-.37-.07-.73-.12-1.09zM506.61 214.84a2.14 2.14 0 0 1-1.29.44c-2.58.22-5.08-.79-7.47-1.79-4-1.66-8.36-3.68-10-7.67-.74-1.78-.84-3.76-1.41-5.61a26.45 26.45 0 0 0-2.75-5.47 81.81 81.81 0 0 1-7.66-17.49 26.91 26.91 0 0 1-.72-2.81c-.07.33-.13.67-.17 1a15.18 15.18 0 0 0 .89 5.8 81.81 81.81 0 0 0 7.66 17.49 26.45 26.45 0 0 1 2.75 5.47c.57 1.85.67 3.83 1.41 5.61 1.66 4 6 6 10 7.67 2.39 1 4.89 2 7.47 1.79a1.74 1.74 0 0 0 1.87-1.77 6.63 6.63 0 0 0-.3-3 1.21 1.21 0 0 1-.28.34zM516.99 208.7a3.19 3.19 0 0 1-1.31.31 28.7 28.7 0 0 1-10.5-1.25 6.75 6.75 0 0 1 2.05 4.55 28.59 28.59 0 0 0 8.45.7 1.69 1.69 0 0 0 1.82-2.48c-.15-.62-.33-1.23-.51-1.83z"
  })), React.createElement("path", {
    d: "M377.44 230.74s-1 20.5 2 22-2-22-2-22zM434.19 284.74c1 0 5 2 5.5 4.25s-5.5-4.25-5.5-4.25zM431.69 287.99c1 0 5 2 5.5 4.25s-5.5-4.25-5.5-4.25zM440.94 296.99c1 0 5 2 5.5 4.25s-5.5-4.25-5.5-4.25zM428.44 297.37s-13.58 13.59-14.42 16.5-26.5 3-26.5 3l-1.75-14s-.1-.37-.19-.93c7.09-1.82 30.08-10.31 43.76-7.3a3.09 3.09 0 0 1-.9 2.73z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M366.6 314.57s13.09-11.58 17.09-11.33 52.75-20.5 56 2.75-62.25 24.5-62.25 24.5l-10 3.75s-8.34-18.17-.84-19.67z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M362.77 316.24s6-8.33 7.83 1.83 4.59 22.67 4.59 22.67l-13.42-6.67z",
    fill: "#d39999"
  }), React.createElement("ellipse", {
    cx: 918.38,
    cy: 664.49,
    rx: 44.79,
    ry: 6.87,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 791.95,
    cy: 788.53,
    rx: 70,
    ry: 10.74,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 981.95,
    cy: 826.53,
    rx: 92.59,
    ry: 14.21,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 70,
    cy: 678.54,
    rx: 70,
    ry: 10.74,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M883.06 598.58s-6.33 29.5 21.85 33l1.75-3.28s-21.85-20.54-23.6-29.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M915.62 628.07l-6.55 1.39-.66.15s-17.48-14.2-17.26-45.89a79.56 79.56 0 0 0 8.35 13.22c6.93 9.16 14.77 21.43 16.12 31.13z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M917.84 631.11a4.1 4.1 0 0 1-3.53.46c-16.83-3.93-11.14-58.77-11.14-58.77.93.44 2 7.41 5.82 16.42 6.79 15.82 14.28 37.92 8.85 41.89zM955.16 598.58s1.1 29.5-27.09 33l-1.75-3.28s27.1-20.54 28.84-29.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M947.08 583.72c.21 31.69-22.5 45.89-22.5 45.89l-.66-.15-6.55-1.39c1.29-9.73 9.19-22 16.11-31.13a70.9 70.9 0 0 1 13.6-13.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M923.82 628.24a10.39 10.39 0 0 1-3.75 2.87 6.69 6.69 0 0 1-1.37.46c-4.15 1-5.59-2-5.35-7.09.39-9 6.07-24.7 11.17-36.42 3.67-8.44 9.67-14.84 10.56-15.26-.02 0-.27 42.7-11.26 55.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M919.11 553.57s-18.79 66.64-2.62 76.69 6.78-70.79 2.62-76.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M883.06 598.58s-6.33 29.5 21.85 33l1.75-3.28s-21.85-20.54-23.6-29.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M915.62 628.07l-6.55 1.39-.66.15s-17.48-14.2-17.26-45.89a79.56 79.56 0 0 0 8.35 13.22c6.93 9.16 14.77 21.43 16.12 31.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M917.84 631.11a4.1 4.1 0 0 1-3.53.46c-16.83-3.93-11.14-58.77-11.14-58.77.93.44 2 7.41 5.82 16.42 6.79 15.82 14.28 37.92 8.85 41.89zM955.16 598.58s1.1 29.5-27.09 33l-1.75-3.28s27.1-20.54 28.84-29.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M947.08 583.72c.21 31.69-22.5 45.89-22.5 45.89l-.66-.15-6.55-1.39c1.29-9.73 9.19-22 16.11-31.13a70.9 70.9 0 0 1 13.6-13.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M923.82 628.24a10.39 10.39 0 0 1-3.75 2.87 6.69 6.69 0 0 1-1.37.46c-4.15 1-5.59-2-5.35-7.09.39-9 6.07-24.7 11.17-36.42 3.67-8.44 9.67-14.84 10.56-15.26-.02 0-.27 42.7-11.26 55.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M919.11 553.57s-18.79 66.64-2.62 76.69 6.78-70.79 2.62-76.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M883.06 598.58s-3.71 29.5 24.47 33l1.75-3.28s-24.47-20.54-26.22-29.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M918.27 628.07l-6.55 1.39-.66.15s-20.1-14.2-19.88-45.89c0 0 5.15 5.52 11 13.22 6.88 9.16 14.75 21.43 16.09 31.13z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M918.27 628.07l-6.55 1.39c-6.21-5.45-8.68-19.69-9.57-32.52 6.91 9.16 14.78 21.43 16.12 31.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M920.46 631.11a4.1 4.1 0 0 1-3.53.46c-16.83-3.93-13.76-58.77-13.76-58.77.93.44 4.57 7.41 8.44 16.42 6.79 15.82 14.25 37.92 8.85 41.89zM955.16 598.58s3.72 29.5-24.47 33l-1.74-3.28s24.47-20.54 26.21-29.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M947.08 583.72c.21 31.69-19.88 45.89-19.88 45.89l-.66-.15-6.55-1.39c1.3-9.73 9.19-22 16.11-31.13 5.83-7.7 10.98-13.22 10.98-13.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M936.1 596.94c-.84 12-3 25.14-8.35 31.3a10 10 0 0 1-1.21 1.22l-6.55-1.39c1.28-9.7 9.19-21.97 16.11-31.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M926.44 628.24a10.31 10.31 0 0 1-3.75 2.87 7 7 0 0 1-1.38.46c-4.14 1-5.59-2-5.35-7.09.39-9 6.07-24.7 11.17-36.42 3.67-8.44 7-14.84 7.94-15.26-.01 0 2.37 42.7-8.63 55.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M920.46 631.11a4.61 4.61 0 0 1-2.66-.85c-7.92-4.93-8.08-23.44-6.19-41 6.79 15.78 14.25 37.88 8.85 41.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M926.44 628.24c-.91 2-2.14 3-3.75 2.87a5.25 5.25 0 0 1-2.26-.85 12 12 0 0 1-4.47-5.78c.39-9 6.07-24.7 11.17-36.42 1.81 16.31 2.41 33.51-.69 40.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M919.11 553.57s-16.16 66.64 0 76.69 4.16-70.79 0-76.69z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#4b4770",
    d: "M950.14 626.99h-67.29v11.14h10.26l.26 1.31 4.11 21.63h39.12l4.11-21.63.25-1.31h9.18v-11.14z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M950.14 626.99h-67.29v11.14h10.26l.26 1.31 4.11 21.63h39.12l4.11-21.63.25-1.31h9.18v-11.14z"
  }), React.createElement("path", {
    fill: "#4b4770",
    d: "M944.46 633.54l-1.12 5.9-4.12 21.63H900.1l-4.11-21.63-1.13-5.9h49.6z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M944.46 633.54l-1.12 5.9h-47.35l-1.13-5.9h49.6z"
  }), React.createElement("path", {
    fill: "#4b4770",
    d: "M885.47 626.99h67.29v11.14h-67.29z"
  }), React.createElement("path", {
    d: "M109.15 561.16a17.18 17.18 0 0 0-2.28 4.29c-.14.37-.28.8-.42 1.21a3.69 3.69 0 0 0-.79-.27 11.05 11.05 0 0 0-3.57-.31c0-.46.06-1 .07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82 3-1.38 8 1.73 11.2.27.28.54.54.8.79-2.84 2-3.38 6.73-3.85 11.64s-4.64 10.28-7.41 13.34c-.28.31-.53.59-.78.85a10.1 10.1 0 0 0-8-2.07c-.11-.43-.23-.88-.37-1.36-2.29-8.13-6.93-22.13-12.87-25.13.25-.31.51-.63.78-1 2.52-3.3 5.36-8.2 1.17-9.45s-4.57 4.25-4.34 8.37c0 .51.08 1 .12 1.46a6.14 6.14 0 0 0-4.37 2.12l-.65-.77c-3.4-4-9.63-10.36-11.52-5.55-1.75 4.47 3.73 10.29 7.59 13.66l.24.21c-2.59 10.52 8.72 19.09 14.81 22.83l.79.49c-8.4 9.89-13.59 28.45-13.59 28.45l23.53 4.2s15.59-13.46 13.59-26.09h.16c15.59-3.13 19.13-19.75 16.71-29.61l.27-.12a17.7 17.7 0 0 0 7.22-5.45c4.35-6.07-4.79-12.91-9.27-6.96z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M109.15 561.16a17.18 17.18 0 0 0-2.28 4.29c-.14.37-.28.8-.42 1.21a3.69 3.69 0 0 0-.79-.27 11.05 11.05 0 0 0-3.57-.31c0-.46.06-1 .07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82 3-1.38 8 1.73 11.2.27.28.54.54.8.79-2.84 2-3.38 6.73-3.85 11.64s-4.64 10.28-7.41 13.34c-.28.31-.53.59-.78.85a10.1 10.1 0 0 0-8-2.07c-.11-.43-.23-.88-.37-1.36-2.29-8.13-6.93-22.13-12.87-25.13.25-.31.51-.63.78-1 2.52-3.3 5.36-8.2 1.17-9.45s-4.57 4.25-4.34 8.37c0 .51.08 1 .12 1.46a6.14 6.14 0 0 0-4.37 2.12l-.65-.77c-3.4-4-9.63-10.36-11.52-5.55-1.75 4.47 3.73 10.29 7.59 13.66l.24.21c-2.59 10.52 8.72 19.09 14.81 22.83l.79.49c-8.4 9.89-13.59 28.45-13.59 28.45l23.53 4.2s15.59-13.46 13.59-26.09h.16c15.59-3.13 19.13-19.75 16.71-29.61l.27-.12a17.7 17.7 0 0 0 7.22-5.45c4.35-6.07-4.79-12.91-9.27-6.96z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M62.33 567.94l-2.75 8s-1.53-1.08-3.46-2.78c-3.86-3.37-9.34-9.19-7.59-13.66 1.89-4.81 8.12 1.54 11.52 5.55 1.37 1.65 2.28 2.89 2.28 2.89zM68.13 563.37a38.89 38.89 0 0 1-2.68 3.15 42.22 42.22 0 0 1-.49-4.23c-.23-4.12.21-9.59 4.34-8.37s1.35 6.13-1.17 9.45zM103.6 564.61c-.08 2.65-.34 4.77-.34 4.77a33.41 33.41 0 0 1-3.43-3.07c-3.11-3.22-6.55-8.2-1.73-11.2 5.03-3.11 5.65 4.26 5.5 9.5zM119.85 568.09a17.7 17.7 0 0 1-7.22 5.45 19.38 19.38 0 0 1-2.42.88l-3.24-4.55a33.05 33.05 0 0 1 1.34-4.42 17.18 17.18 0 0 1 2.28-4.29c4.48-5.95 13.62.89 9.26 6.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M60.05 565.1c1.37 1.6 2.28 2.84 2.28 2.84l-2.75 8s-1.53-1.08-3.46-2.78a15.7 15.7 0 0 1 3.1-7.07c.27-.32.56-.67.83-.99zM68.13 563.37a38.89 38.89 0 0 1-2.68 3.15 42.22 42.22 0 0 1-.49-4.23 5.46 5.46 0 0 1 3.17 1.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M81.66 595.3l-6.85 3s-1.49-.72-3.64-2.06c-7.19-4.42-21.64-15.55-12-28.67s17.77 10.41 21 21.92c.97 3.45 1.49 5.81 1.49 5.81z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M99.83 566.31a5.64 5.64 0 0 1 3.77-1.7c-.08 2.65-.34 4.77-.34 4.77a33.41 33.41 0 0 1-3.43-3.07zM112.63 573.54a19.38 19.38 0 0 1-2.42.88l-3.24-4.55a33.05 33.05 0 0 1 1.34-4.42c2.09 1.22 3.63 4.26 4.32 8.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M95.65 603.27l-1.15.2c-22.93 3.48-7.56-8.89-7.56-8.89s1-1 2.43-2.5c2.77-3.06 6.93-8.4 7.41-13.34.72-7.43 1.55-14.4 10.32-12.35 8.61 1.98 10.26 32.53-11.45 36.88z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M51.41 660.36h43.81v11.52H51.41z"
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M44.45 622.91h57.24v40.2H44.45z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M51.41 660.36h43.81v11.52H51.41z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M44.45 622.91h57.24v40.2H44.45z"
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M54.29 660.36H98.1v11.52H54.29z"
  }), React.createElement("path", {
    d: "M80.17 589.5c1 3.44 1.49 5.8 1.49 5.8l-6.85 3s-1.49-.72-3.64-2.06c2.68-3.38 5.7-5.95 9-6.74zM95.65 603.27l-1.15.2c-22.93 3.48-7.56-8.89-7.56-8.89s1-1 2.43-2.5c4.28 3.42 6.05 7.29 6.28 11.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M58.37 625.19s12.84-46 30.85-31.8-7.32 36-7.32 36z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 64.85,
    cy: 574.79,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 64.73,
    cy: 581.51,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 106.5,
    cy: 576.11,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 72.89,
    cy: 610.55,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 103.5,
    cy: 587.27,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 88.62,
    cy: 602.15,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 69.77,
    cy: 577.67,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 102.54,
    cy: 580.43,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 97.62,
    cy: 591.59,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 82.5,
    cy: 609.47,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 79.38,
    cy: 602.39,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 71.93,
    cy: 586.43,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M54.29 660.36H98.1v4.21H54.29z"
  }), React.createElement("path", {
    fill: "#d4dfec",
    d: "M47.33 622.91h57.24v40.2H47.33z"
  }), React.createElement("circle", {
    cx: 84.42,
    cy: 615.95,
    r: 1.44,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 75.78,
    cy: 617.75,
    r: 1.44,
    opacity: 0.1
  }));
};

UndrawBaby.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawBaby;